// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/index.css' // global css
import 'babel-polyfill'
import axios from 'axios'
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
import store from './store'  
import App from './App'
import router from './router'
import md5 from 'js-md5';
import './permission' // permission control
import conFun from './config/common.js'	
Vue.prototype.$conFun = conFun;


// 弹幕评论插件
import { vueBaberrage } from 'vue-baberrage'
Vue.use(vueBaberrage)
// 直播视频插件
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import 'videojs-contrib-hls' //单是 RTMP 的话不需要第三方库，如果是 HLS 的话需要引入videojs-contrib-hls，看具体情况而定。
Vue.use(VideoPlayer);
import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";
Vue.use(VueDPlayer);



Vue.use(ElementUI);
Vue.config.productionTip = false

// 获取屏幕宽高
Vue.prototype.$getViewportSize = function(){
  return{
    width:window.innerWidth || document.documentElement.clientWidth ||document.body.clientWidth, //兼容性获取屏幕宽度
    height:window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight //兼容性获取屏幕高度
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js